var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:[
    _vm.$style.tabsItem,
    _vm.itemData.groupType === _vm.defaultPaymentTabsActived
      ? _vm.$style.tabsItemSel
      : _vm.$style.tabsItemNor
  ],on:{"click":function($event){return _vm.onChange(_vm.itemData)}}},[_c('div',{class:_vm.$style.tabsItemTop},[_c('div',{class:_vm.$style.logo},[_c('IconCreditCard',{attrs:{"type":_vm.itemData.groupType}})],1)]),_c('div',{class:_vm.$style.tabsItemTitle},[_vm._v(" "+_vm._s(_vm.$t(_vm.itemData.title))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }